<template>
  <div>
    <div
      v-if="loading"
      style="display: flex; top: 0px; position: fixed; left: 0px; right: 0px; bottom: 0px; background-color: rgba(247, 247, 247, 0.9); z-index: 9999; justify-content: center; align-items: center;"
    >
      <div>
        <div>
          <h3>Getting Promo details ready...</h3>
        </div>
      </div>
    </div>

    <div class="order--main-content">
      <div class="row align-items-center justify-content-between mb-2">
        <div class="col">
          <router-link :to="{ name: 'Promos' }" class="arrow_text">
            <chevron-left-icon
              size="1.5x"
              class="custom-class"
              style="vertical-align: top;"
            ></chevron-left-icon>
            <span class="back">Back</span>
          </router-link>
        </div>
      </div>
      <h1 class="mt-2 mb-3 font-regular" v-if="formObj">
        &nbsp;&nbsp; Promo Details
      </h1>

      <div class="row mb-5">
        <div class="col-lg-12">
          <ul class="nav nav-tabs nav-overflow header-tabs">
            <li class="nav-item">
              <a
                class="nav-link"
                href="javascript:void(0)"
                v-on:click="activetab = 1"
                v-bind:class="[activetab === 1 ? 'active' : '']"
              >
                Promo Details
              </a>
            </li>
            <li class="nav-item">
              <a
                class="nav-link"
                href="javascript:void(0)"
                v-on:click="activetab = 2"
                v-bind:class="[activetab === 2 ? 'active' : '']"
              >
                Promo Users
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div class="row" v-if="activetab === 1 && formObj !== null">
        <div class="col-md-12">
          <div class="card card--no-shadow card-profile">
            <div class="card-header">
              <h3 class="font-weight-600 mb-0">Promo Information</h3>
            </div>
            <div class="card-content card-body">
              <form @submit.prevent="createPromo">
                <div class="row">
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="name">Name</label>
                      <input
                        type="text"
                        v-model="formObj.name"
                        class="form-control"
                        placeholder="Promo's Name"
                      />
                    </div>
                  </div>

                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="daily_limit">Daily Limit</label>
                      <input
                        type="text"
                        v-model="formObj.daily_limit"
                        @keypress="isNumber($event)"
                        class="form-control"
                        placeholder="Promo's Daily Limit"
                      />
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="daily_limit">User Daily Limit</label>
                      <input
                        type="text"
                        v-model="formObj.user_daily_limit"
                        @keypress="isNumber($event)"
                        class="form-control"
                        placeholder="Promo's Daily Limit"
                      />
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="code">Code</label>
                      <input
                        type="text"
                        v-model="formObj.code"
                        class="form-control"
                        placeholder="Promo code"
                      />
                    </div>
                  </div>
                  <div class="col-md-12">
                    <div class="form-group">
                      <label for="daily_limit">Description</label>
                      <textarea
                        type="text"
                        v-model="formObj.description"
                        class="form-control"
                      />
                    </div>
                  </div>

                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="monthly_limit">Monthly Limit</label>
                      <input
                        type="text"
                        v-model="formObj.monthly_limit"
                        @keypress="isNumber($event)"
                        class="form-control"
                        placeholder="Promo's Monthly Limit"
                      />
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="user_limit">User Limit</label>
                      <input
                        type="text"
                        v-model="formObj.user_limit"
                        @keypress="isNumber($event)"
                        class="form-control"
                        placeholder="Promo's User Limit"
                      />
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="promo_type">Promo Type</label>
                      <select
                        name=""
                        v-model="formObj.type"
                        id=""
                        class="form-control"
                      >
                        <option value="" disabled selected
                          >Pleease Select Type</option
                        >
                        <option value="percent">Percent</option>
                        <option value="flat">Flat</option>
                      </select>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="value">Value</label>
                      <input
                        type="text"
                        v-model="formObj.value"
                        @keypress="isNumber($event)"
                        class="form-control"
                        placeholder="Promo's Value"
                      />
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="cap">Cap</label>
                      <input
                        type="text"
                        v-model="formObj.cap"
                        @keypress="isNumber($event)"
                        class="form-control"
                        placeholder="Promo's Cap"
                      />
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="cap">Min Transaction Amount</label>
                      <input
                        type="text"
                        v-model="formObj.min_transaction_amount"
                        @keypress="isNumber($event)"
                        class="form-control"
                        placeholder="Promo's Min Amount"
                      />
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="promo_category">Promo Category</label>
                      <select
                        name=""
                        v-model="formObj.category"
                        id=""
                        class="form-control"
                      >
                        <option value="" disabled selected
                          >Pleease Select Type</option
                        >
                        <option value="referral">Referral</option>
                        <option value="new-user-bonus">New User Bonus</option>
                        <option value="cashback">Airtime Cashback</option>
                      </select>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class=" form-group">
                      <label for="start_date">Start Date</label>
                      <input
                        type="date"
                        v-model="formObj.start_date"
                        class="form-control"
                      />
                    </div>
                  </div>

                  <div class="col-md-6">
                    <div class=" form-group">
                      <label for="end_date">End Date</label>
                      <input
                        type="date"
                        v-model="formObj.end_date"
                        class="form-control"
                      />
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="">Status</label>
                      <select
                        name=""
                        id=""
                        class="form-control"
                        v-model="formObj.status"
                      >
                        <option value="" disabled selected
                          >Please Select Status</option
                        >
                        <option value="active">Active</option>
                        <option value="inactive">Inactive</option>
                      </select>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class=" form-group">
                      <label for="start_date">Cap Message</label>
                      <input
                        type="text"
                        v-model="formObj.cap_message"
                        class="form-control"
                      />
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class=" form-group">
                      <label for="start_date">Service IDs</label>
                      <input
                        type="text"
                        v-model="formObj.service_ids"
                        class="form-control"
                      />
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class=" form-group">
                      <label for="start_date">Start Date</label>
                      <input
                        type="date"
                        v-model="formObj.start_date"
                        class="form-control"
                      />
                    </div>
                  </div>
      
                  <div class="col-md-6">
                    <div class=" form-group">
                      <label for="end_date">End Date</label>
                      <input
                        type="date"
                        v-model="formObj.end_date"
                        class="form-control"
                      />
                    </div>
                  </div>
                </div>
                <div class="row justify-content-end">
                  <button
                    class="btn btn-primary"
                    @submit.prevent="createUpdatePromo"
                    :disabled="formIsNotValid || formLoading"
                  >
                    <span class="custom-loader" v-if="formLoading">
                      <loader-icon
                        size="1.5x"
                        class="custom-class"
                      ></loader-icon>
                      <span style="font-weight: 600; text-transform: initial;">
                        Updating ...
                      </span>
                    </span>
                    <span v-else>
                      Update Promo
                    </span>
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ApiService from "../../services/api.service";
import CDataTable from "../../components/CDataTable.vue";
import CPaginationVue from "../../components/CPagination.vue";
import Swal from "sweetalert2";
import { ChevronLeftIcon } from "vue-feather-icons";
import ErrorService from "../../services/error.service";

export default {
  name: "PromoPage",
  props: {
    slug: {
      type: [String, Number],
      required: true
    }
  },
  computed: {
    permissions() {
      return this.$store.getters.permissions;
    },
    formIsNotValid() {
      for (let key in this.formObj) {
        if (this.formObj.hasOwnProperty(key) && this.formObj[key] === "") {
          return true;
        }
      }
      return false;
    }
  },
  data() {
    return {
      formLoading: false,
      formObj: null,
      loading: false,
      activetab: 1
    };
  },
  methods: {
    isNumber: function(evt) {
      console.log(evt.key);
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },

    async createPromo() {
      this.formLoading = true;
      console.log(this.formObj);
      try {
        const res = await ApiService.post("promo/create-update", this.formObj);

        // this.closeModal();
        this.formLoading = false;
        Swal.fire({
          title: "Success",
          text: res.data.message,
          icon: "success",
          timer: 3000,
          confirmButtonText: "Close",
          showConfirmButton: false
        });

        this.getData();
      } catch (error) {
        console.log(error);
        let _error = error.response.data;
        ErrorService.displayErrorAlert(_error);
        this.formLoading = false;
      }
    },
    async getData() {
      try {
        this.loading = true;
        const res = await ApiService.get(`promo/view/${this.slug}`);
        this.formObj = res.data.data;
        this.loading = false;
      } catch (error) {
        this.loading = false;
        console.log(error);
      }
    }
  },
  mounted() {
    this.getData();
  }
};
</script>

<style scoped></style>
